import { use } from 'echarts/lib/echarts';
import { install } from './lines3D/install';
use(install);